import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    GeneralTask,
    PersonsOrganisationDto,
    TaskCategory
} from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GeneralTaskAddDialogueComponent } from './add-task/general-task-add-dialogue.component';
import { GeneralTaskDetailsDialogueComponent } from './general-task-details-dialogue/general-task-details-dialogue.component';
import { GeneralTasksDataService } from './general-tasks-data.service';

@Injectable()
export class GeneralTasksDialoguesService {
    constructor(private modalService: BsModalService, private router: Router) {}

    showAddTaskDialogue(
        organisation: PersonsOrganisationDto,
        generalTasksDataService: GeneralTasksDataService,
        category?: TaskCategory
    ) {
        return this.modalService.show(GeneralTaskAddDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-md',
            initialState: {
                organisation,
                category: category || TaskCategory.GENERAL
            },
            providers: [
                {
                    provide: GeneralTasksDataService,
                    useValue: generalTasksDataService
                }
            ]
        });
    }

    showTaskDetailsDialogue(
        task: GeneralTask,
        organisation: PersonsOrganisationDto,
        generalTasksDataService: GeneralTasksDataService
    ) {
        return this.modalService.show(GeneralTaskDetailsDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                taskId: task.id,
                organisation
            },
            providers: [
                {
                    provide: GeneralTasksDataService,
                    useValue: generalTasksDataService
                }
            ]
        });
    }

    showTaskEditDialogue(
        task: GeneralTask,
        organisation: PersonsOrganisationDto,
        generalTasksDataService: GeneralTasksDataService
    ) {
        return this.modalService.show(GeneralTaskDetailsDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                taskId: task.id,
                organisation,
                isEditing: true
            },
            providers: [
                {
                    provide: GeneralTasksDataService,
                    useValue: generalTasksDataService
                }
            ]
        });
    }
}
